import React, { useRef, useState } from "react";

import CloseIcon from "../../Assets/Images/close-white-icon.svg";
import CheckIcon from "../../Assets/Images/check-white-icon.svg";

import TermPrIcon from "../../Assets/Images/product-t1.svg";
import UniversalPrIcon from "../../Assets/Images/product-t2.svg";
import IndexaPrIcon from "../../Assets/Images/product-t3.svg";
import CriticlePrIcon from "../../Assets/Images/product-t4.svg";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

import "./Compare.css";

const CompareMobile = () => {
  const translations = useTranslation(); // Get translations dynamically
  const sectionRefs = {
    section1: useRef(null),
    section2: useRef(null),
    section3: useRef(null),
    section4: useRef(null),
    section5: useRef(null),
    section6: useRef(null),
    section7: useRef(null),
    section8: useRef(null),
  };

  const [isSyncing, setIsSyncing] = useState(false);

  const staticData = [
    "",
    translations.guaranteedPremium,
    translations.cashValue,
    translations.premiumFlexibility,
    translations.deathBenefit,
    translations.loanDuration,
    translations.permanentPolicy,
    translations.interestCredit,
  ];

  const data = [
    {
      section1: {
        title: "Term",
        content: `<p>Term Individuals and families who need affordable coverage for a limited period.</p> <p>It guarantees the payment of a pre-established death benefit to the insured's beneficiaries if the insured dies during the specified term.</p>`,
        headIcon: TermPrIcon,
      },
      section2: {
        title: null,
        content: null,
        isIcon: CheckIcon,
        staticText: "(During the term)",
      },
      section3: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
      section4: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
      section5: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
      section6: {
        title: null,
        content: null,
        isIcon: CheckIcon,
      },
      section7: {
        title: null,
        content: null,
        isIcon: CheckIcon,
      },
      section8: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
    },
    {
      section1: {
        title: "Universal (Prime + Ultra III) ",
        content: `<p>People looking for flexibility in their insurance.</p> <p>Those who wish to adjust premiums and death benefits. Individuals interested in accumulating cash value.</p>`,
        headIcon: UniversalPrIcon,
      },
      section2: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
      section3: {
        title: null,
        content: null,
        isIcon: CheckIcon,
      },
      section4: {
        title: null,
        content: null,
        isIcon: CheckIcon,
      },
      section5: {
        title: null,
        content: null,
        isIcon: CheckIcon,
      },
      section6: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
      section7: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
      section8: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
    },
    {
      section1: {
        title: "Indexa Pro IUL",
        content: `<p>For those looking for cash value growth potential based on the  <strong>S&P 500® INDEX</strong>.</p><p>People willing to take moderate risk for higher returns.</p><p>Those who want a combination of long-term performance and life insurance.</p>`,
        headIcon: IndexaPrIcon,
      },
      section2: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
      section3: {
        title: null,
        content: null,
        isIcon: CheckIcon,
      },
      section4: {
        title: null,
        content: null,
        isIcon: CheckIcon,
      },
      section5: {
        title: null,
        content: null,
        isIcon: CheckIcon,
      },
      section6: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
      section7: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
      section8: {
        title: null,
        content: null,
        isIcon: CheckIcon,
      },
    },
    {
      section1: {
        title: "Critical Illness",
        content: `<p>A product, designed with a previously stipulated benefit.</p> <p>It is activated at the critical moment of diagnosis of a serious illness (as described in the policy), providing essential financial support.</p>`,
        headIcon: CriticlePrIcon,
      },
      section2: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
      section3: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
      section4: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
      section5: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
      section6: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
      section7: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
      section8: {
        title: null,
        content: null,
        isIcon: CloseIcon,
      },
    },
  ];

  const handleScroll = (event, section) => {
    if (isSyncing) return;

    const scrollLeft = event.target.scrollLeft;
    setIsSyncing(true);

    Object.keys(sectionRefs).forEach((key) => {
      if (key !== section && sectionRefs[key].current) {
        sectionRefs[key].current.scrollLeft = scrollLeft;
      }
    });

    setTimeout(() => setIsSyncing(false), 50);
  };

  return (
    <div className="product-compare-mobile mt-6 block md:hidden">
      {Object.keys(sectionRefs).map((section, index) => (
        <div key={section}>
          <div className="compare-table-title bg-[#EBE9E5] text-[12px] font-semibold bg-opacity-50 rounded-[36px] text-center p-2 leading-[17px] tracking-tight  mx-4">
            {staticData[index]}
          </div>
          <div
            ref={sectionRefs[section]}
            onScroll={(e) => handleScroll(e, section)}
            className="flex overflow-x-auto w-full  pl-5 ml-1 compare-head-row whitespace-nowrap"
          >
            {data.map((row, rowIndex) => (
              <div
                key={rowIndex}
                className="min-w-[148px]  flex flex-col   m-1 p-2 pt-4 pb-5 rounded whitespace-normal"
              >
                {row[section]?.headIcon && (
                  <div className="top-header-product-icon">
                    <img src={row[section].headIcon} alt="" />
                  </div>
                )}
                {row[section]?.title && (
                  <h6 className="text-lg font-bold">{row[section].title}</h6>
                )}
                {row[section]?.content && (
                  <div
                    dangerouslySetInnerHTML={{ __html: row[section].content }}
                  ></div>
                )}

                <div className="flex gap-2">
                  {!row[section]?.content ? (
                    row[section]?.isIcon ? (
                      <>
                        <div className="check-close-icon">
                          <img
                            className={row[section]?.isIcon}
                            src={row[section]?.isIcon}
                            alt=""
                          />
                        </div>
                        {row[section]?.staticText && (
                          <p>{row[section]?.staticText}</p>
                        )}
                      </>
                    ) : null
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CompareMobile;
